module.exports = __webpack_public_path__ + "static/media/Grace_O'Toole.ded69bec.png";